<template>
  <div id="ecommerce_product">
    <div v-if="state == 'list'">
      <v-container>
        <div>
          <v-layout wrap v-if="productlist && productlist.length > 0">
            <v-flex xs12 sm7 lg9 class="pl-1"></v-flex>
            <v-flex xs12 sm5 lg3 class="form-control pa-2">
              <input
                type="text"
                class="form-control ma-0"
                v-model="search"
                :placeholder="$t('Search')"
              />
            </v-flex>
          </v-layout>
        </div>
        <template>
          <h3 class="headline mt-3">{{$t('Products')}}</h3>

          <template v-if="!loadingProduct">
            <v-layout wrap v-if=" filterProducts && filterProducts.length > 0">
              <v-flex xs12 sm1>
                <v-select
                  :items="pagelimit"
                  solo
                  v-model="size"
                  @change="onChangeLimit"
                  small
                  class="browser-default mb-2"
                  hide-details
                ></v-select>
              </v-flex>
              <v-flex xs12 sm11 class="text-xs-center text-sm-right">
                <v-pagination
                  v-model="pageNumber"
                  :length="pageCount"
                  @input="onClickPageinate"
                  class="mb-2"
                ></v-pagination>
              </v-flex>
            </v-layout>

            <v-layout wrap>
              <v-flex
                xs12
                sm6
                md4
                lg3
                xl2
                class="pa-1"
                v-if="!(selectedBot.useketshop == true && selectedBot.ketshop_api_key && selectedBot.ketshop_api_secret)"
              >
                <div
                  class="btn-add"
                  @click="onAddNewProduct"
                  style="position:relative;min-height: 200px;cursor: pointer; height: 100%"
                >
                  <div style="position:absolute; top: 50%; margin-top: -50px; left: 0; right: 0">
                    <div class="text-xs-center">
                      <h3 class="headline" style="color:#969595">
                        <i class="fa fa-plus"></i>
                      </h3>
                      <p>{{$t('Add new product')}}</p>
                    </div>
                  </div>
                  <template
                    v-if="$store.getters.getPackage != 'premium' && productlist.length >= maxProduct"
                  >
                    <v-premium-plan-popup :showAll="false" marginTop="65" :size="'small'"></v-premium-plan-popup>
                  </template>
                </div>
              </v-flex>
              <template v-if="filterProducts && filterProducts.length > 0">
                <template v-for="(product,index) in filterProducts">
                  <v-flex xs12 sm6 md4 lg3 xl2 class="pa-1" :key="'product_'+product.id">
                    <product
                      v-model="filterProducts[index]"
                      @productDeleted="onDeleteProduct(index)"
                      @onSelectedProduct="onSelectedProduct(index, product)"
                    ></product>
                  </v-flex>
                </template>
              </template>
            </v-layout>

            <v-layout wrap v-if="filterProducts && filterProducts.length > 0" class="mt-3">
              <v-flex xs12 sm1>
                <v-select
                  :items="pagelimit"
                  solo
                  v-model="size"
                  @change="onChangeLimit"
                  small
                  class="mb-2"
                  hide-details
                ></v-select>
              </v-flex>
              <v-flex xs12 sm11 class="text-xs-center text-sm-right">
                <v-pagination
                  v-model="pageNumber"
                  :length="pageCount"
                  @input="onClickPageinate"
                  class="mb-2"
                ></v-pagination>
              </v-flex>
            </v-layout>
          </template>
          <template v-else>
            <div style="padding: 30px 0">
              <scale-loader :color="$store.state.theme.brand_color" height="45px" width="7px"></scale-loader>
            </div>
          </template>
          <div class="mb-5 mt-5"></div>
        </template>
      </v-container>
    </div>
    <div v-else-if="state == 'add-product'">
      <template v-if="state == 'add-product'">
        <v-container>
          <modal-add-product @onAddProduct="addProduct" @close="state = 'list'"></modal-add-product>
        </v-container>
      </template>
    </div>
    <div v-else-if="state == 'edit-product'">
      <template v-if="currentProduct">
        <v-container>
          <modal-edit-product
            v-model="currentProduct"
            @close="state = 'list'"
            @onSaveProduct="closeEditProduct"
          ></modal-edit-product>
        </v-container>
      </template>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Product from './Product'
import ModalAddProduct from './ModalAddProduct'
import ModalEditProduct from './ModalEditProduct'
import ScaleLoader from 'vue-spinner/src/ScaleLoader.vue'
import ModalHelp from '@/components/elements/ModalHelp'

import api from '@/api'

export default {
  data: function() {
    return {
      pageNumber: 1,
      size: 10,
      currentProduct: undefined,
      currentFilter: 'all',
      productlist: [],
      selectedProduct: null,
      showModal: false,

      loadingProduct: true,

      pagelimit: [10, 25, 50],

      filterBadge: {
        all: 0,
        sales: 0,
        soldout: 0
      },

      productCount: 0,

      search: '',
      state: 'list',
      maxProduct: 10
    }
  },
  components: {
    Product,
    ModalAddProduct,
    ModalEditProduct,
    ScaleLoader,
    ModalHelp
  },
  mounted: function() {
    let vm = this
    // vm.$store.dispatch("loading")
    vm.getProducts(function() {
      vm.loadingCategory = false
      // vm.$store.dispatch("loading")
    })
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    }),
    filterProducts: function() {
      let products = []
      let vm = this
      vm.filterBadge = {
        all: vm.productlist.length,
        sales: 0,
        soldout: 0
      }

      // $.each(vm.productlist, function(index, val) {
      // if (parseFloat(val.price) > parseFloat(val.discountprice)) {
      // }
      // if (parseFloat(val.price) !== parseFloat(val.discountprice)) {
      //   vm.filterBadge.sales += 1
      // } else {
      //   var isDiscount = false
      //   if (val.productstock) {
      //     val.productstock.map(function(stock, sindex) {
      //       if (parseFloat(stock[3]) > parseFloat(stock[4])) {
      //         isDiscount = true
      //       }
      //     })
      //   }

      //   if (isDiscount) {
      //     vm.filterBadge.sales += 1
      //   }
      // }
      // if (vm.currentCategory === 'sales') {
      //   if (parseFloat(val.price) !== parseFloat(val.discountprice)) {
      //     products.push(val)
      //   } else {
      //     if (val.productstock) {
      //       val.productstock.map(function(stock, sindex) {
      //         if (parseFloat(stock[3]) > parseFloat(stock[4])) {
      //           isDiscount = true
      //         }
      //       })
      //     }

      //     if (isDiscount) {
      //       products.push(val)
      //     }
      //   }
      // } else if (vm.currentCategory === val.categoryid) {
      //   products.push(val)
      // }
      // if (val.productstock.length === 0) {
      //   vm.filterBadge.soldout += 1
      //   if (vm.currentCategory === 'soldout') {
      //     products.push(val)
      //   }
      // } else {
      //   $.each(val.productstock, function(sindex, stock) {
      //     if (stock[2] <= 0) {
      //       vm.filterBadge.soldout += 1
      //       if (vm.currentCategory === 'soldout') {
      //         products.push(val)
      //       }
      //       return false
      //     }
      //   })
      // }
      // })
      // if (vm.currentCategory === 'all') {
      //   products = vm.productlist
      // }
      products = vm.productlist

      var p = []
      if (vm.search === '') {
        p = products
      } else {
        p = products.filter(product => {
          return (
            product.name.toLowerCase().includes(vm.search.toLowerCase()) ||
            (product.code != null && product.code.toLowerCase().includes(vm.search.toLowerCase()))
          )
        })
      }
      this.productCount = p.length

      const start = (this.pageNumber - 1) * this.size
      const end = start + this.size
      return p.slice(start, end)
    },
    pageCount: function() {
      let l = this.productCount
      let s = this.size
      return Math.ceil(l / s)
    }
  },
  methods: {
    onChangeLimit: function(value) {
      this.size = value
      this.pageNumber = 1
      $('html, body').animate({
        scrollTop: 0
      })
    },
    onClickPageinate: function(pageNum) {
      this.pageNumber = pageNum
      $('html, body').animate({
        scrollTop: 0
      })
    },
    onAddNewProduct: function() {
      var vm = this
      if (
        vm.$store.getters.getPackage === 'premium' ||
        (vm.$store.getters.getPackage !== 'premium' && vm.productlist.length < vm.maxProduct)
      ) {
        vm.state = 'add-product'
      }
    },
    closeEditProduct: function() {
      var vm = this
      vm.getProducts(function() {
        vm.$store.dispatch('loading')
        vm.state = 'list'
      })
    },
    onSelectedProduct: function(index, product) {
      this.currentProduct = product
      this.state = 'edit-product'
    },

    getProducts: function(callback) {
      let vm = this
      if (!vm.selectedBot) {
        return
      }
      let data = {
        pageid: vm.selectedBot.pageid
      }
      vm.loadingProduct = true
      vm.productlist = []
      if (
        vm.selectedBot.useketshop == true &&
        vm.selectedBot.ketshop_api_key &&
        vm.selectedBot.ketshop_api_secret
      ) {
        data['ketshop_api_key'] = vm.selectedBot.ketshop_api_key
        data['ketshop_api_secret'] = vm.selectedBot.ketshop_api_secret
      }
      api.getProducts(data, function(error, response) {
        if (error) {
          console.error(error)
          vm.loadingProduct = false
          callback()
          return
        }
        vm.productlist = response.productlist
        vm.loadingProduct = false
        callback()
      })
    },
    addProduct: function(product) {
      this.getProducts(function() {})
      this.$store.dispatch('loading')

      // this.productlist.unshift({
      // 	id : product.id,
      // 	photourl : product.photourl,
      // 	name : product.name,
      // 	description : product.description,
      // 	price : product.price,
      // 	currency : product.currency,
      // 	categoryid : product.categoryid,
      // 	subcategoryid : product.subcategoryid,
      // 	keyword: product.keyword,
      // 	discountprice : product.discountprice,
      // 	code : product.code,

      // 	buttonaction : product.buttonaction,
      // 	buttonname : product.buttonname,
      // 	buttonurl : product.buttonurl,
      // 	productstock : product.productstock
      // })

      // this.productlist = Object.assign([],this.productlist)
    },
    onSelectProduct: function(val) {
      this.selectedProduct = this.productlist.find(product => {
        return product.id == val
      })
    },

    onDeleteProduct: function(index) {
      // vm.productlist.splice(index,1)
      this.getProducts(function() {})
    }
  },
  watch: {
    search: function(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.pageNumber = 1
      }
    },
    showModal: function(newVal, oldVal) {
      if (newVal) {
        $('body').addClass('modal-open')
      } else {
        $('body').removeClass('modal-open')
      }
    },

    productlist: function(newVal, oldVal) {
      let vm = this
      // $.each(vm.productlist,function(index ,val){
      // 	if (val.categoryid != vm.currentCategory.id) {
      // 		vm.productlist.splice(index,1)
      // 		return false;
      // 	}
      // })
    }
  }
}
</script>

<style lang="scss" scoped>
.ketshop-bg-color {
  background-color: rgb(58, 58, 58);
}
</style>



// WEBPACK FOOTER //
// src/components/view/template/hafele/Products.vue